import axios from 'axios';

const handleSearchCep = async (cep: string) => {
  const response = await (
    await axios.get(`https://viacep.com.br/ws/${cep}/json`, {
      headers: {},
    })
  ).data;

  return response;
};

export { handleSearchCep };
